import { apiService } from '../../../../services/api'
import { Lead } from '../../../../types'

export interface ILeadRepository {
  getById(id: string): Promise<Lead>
  update(id: string, data: Partial<Lead>): Promise<Lead>
  checkPhoneExists(phone: string): Promise<{ exists: boolean; lead?: Lead }>
  checkEmailExists(email: string): Promise<{ exists: boolean; lead?: Lead }>
  checkDocumentExists(document: string): Promise<{ exists: boolean; lead?: Lead }>
}

export class LeadRepository implements ILeadRepository {
 async getById(id: string): Promise<Lead> {
 return apiService.getLeadById(id)
 }

 async update(id: string, data: Partial<Lead>): Promise<Lead> {
 return apiService.updateLead(id, data)
 }

 async checkPhoneExists(phone: string): Promise<{ exists: boolean; lead?: Lead }> {
 return apiService.checkLeadByPhone(phone)
 }

async checkEmailExists(email: string): Promise<{ exists: boolean; lead?: Lead }> {
    return apiService.checkLeadByEmail(email)
  }

  async checkDocumentExists(document: string): Promise<{ exists: boolean; lead?: Lead }> {
    return apiService.checkLeadByDocument(document)
  }
}

